import axios from 'axios'
// 创建 axios 实例
const requests = axios.create({
　// baseURL: 'http://sign.lovehaituan.com/api.php',
  baseURL: 'http://10.149.10.203:10010/index/index/dashboardZhunong',
  timeout: 10000 // 请求超时时间
})
 
// 错误处理函数
const err = (error) => {
  if (error.response) {
    if (error.response.status === 403) {
      //console.log('403 error')
    }
    if (error.response.status === 401) {
      //console.log('401 error')
    }
  }
  return Promise.reject(error)
}

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
  return config
}, err)

// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
  const res = response.data
  if (res.code !== 0) {
    return Promise.reject('error')
  } else {
    return res
  }
}, err)

export default requests